import { http } from './http'
import { AppStorage } from '@/core/utils'

const resource = '/api/student'
const teacherPath = resource + '/teacher'
const userValidationResult = () => {
  const user = AppStorage.getUser()
  return user.is_teacher ? teacherPath : resource
}

export default {
  getAlert () {
    return http.get(`${userValidationResult()}/alerts`).then(response => {
      return response
    }
    )
  }
}
